import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div className="md:col-span-1">
            <h3 className="text-lg font-heading font-semibold mb-3">Superbuy Study</h3>
            <p className="text-white/50 text-sm leading-relaxed mb-4">
              An independent educational resource helping international buyers navigate Superbuy with curated spreadsheets, guides, and shopping tips. Not affiliated with Superbuy.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-white/90 transition-all cursor-pointer"
            >
              <i className="ri-external-link-line"></i>
              Visit Main Site
            </a>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/60 mb-4">Quick Links</h4>
            <nav className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-white/50 hover:text-white/80 transition-colors underline underline-offset-4">
                Home
              </Link>
              <Link to="/superbuy-spreadsheet-guide" className="text-sm text-white/50 hover:text-white/80 transition-colors underline underline-offset-4">
                Ultimate Guide
              </Link>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors underline underline-offset-4">
                Main Website
              </a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/60 mb-4">Disclaimer</h4>
            <p className="text-white/40 text-xs leading-relaxed">
              This website is an independent educational resource. We are not affiliated with, endorsed by, or connected to Superbuy or any of its associated brands. All product links redirect to our partner spreadsheet site. Users should conduct their own research before making purchasing decisions. External links open in new tabs with nofollow attributes.
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} Superbuy Study. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-white/30 text-xs hover:text-white/50 transition-colors underline underline-offset-4">
              Privacy Policy
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-white/30 text-xs hover:text-white/50 transition-colors underline underline-offset-4">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}